import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '@chakra-ui/icons';
export const ArrowForwardCircleIcon = ({ fillColor }) => createIcon({
    displayName: 'ArrowForwardCircleIcon',
    viewBox: '0 0 16 16',
    path: (_jsx("path", { d: "M7.67678 0.823223L7.5 0.646446L7.32322 0.823223L6.82322 1.32322L6.64645 1.5L6.82322 1.67678L12.5464 7.4L0.5 7.4H0.25V7.65L0.25 8.35V8.6H0.5L12.5464 8.6L6.82322 14.3232L6.64645 14.5L6.82322 14.6768L7.32322 15.1768L7.5 15.3536L7.67678 15.1768L14.6768 8.17678L14.8536 8L14.6768 7.82322L7.67678 0.823223Z", fill: fillColor })),
});
//# sourceMappingURL=ArrowForwardCircleIcon.js.map